export default "__VITE_ASSET__DY4TeYqG__"